import { ReducerAction } from 'store/modules/types';

import { Types } from './types';

export function consultarParametrosSistemaRedisRequest(): ReducerAction {
	return {
		type: Types.CONSULTAR_PARAMETROS_SISTEMA_REDIS,
		payload: null,
	};
}
export function consultarParametrosSistemaRedisSuccess(
	payload: object,
): ReducerAction {
	return {
		type: Types.CONSULTAR_PARAMETROS_SISTEMA_REDIS_SUCCESS,
		payload,
	};
}
export function consultarParametrosSistemaRedisFailure(): ReducerAction {
	return {
		type: Types.CONSULTAR_PARAMETROS_SISTEMA_REDIS_FAILURE,
		payload: null,
	};
}
export function consultarParametrosSistemaRedisClear(): ReducerAction {
	return {
		type: Types.CONSULTAR_PARAMETROS_SISTEMA_REDIS_CLEAR,
		payload: null,
	};
}
